import React from "react";
import { Navbar } from "../header";
import { Footer } from "../footer";
import "./PortfolioPage.css";

export const CorporateSocialPortfolio = () => {
  const galleryImages = [
    {
      id: 1,
      src: "/resources/images/corporate-social/img1.jpg",
      category: "Corporate Events",
      title: "Professional Excellence"
    },
    {
      id: 2,
      src: "/resources/images/corporate-social/img2.jpg",
      category: "Corporate Events",
      title: "Business Gatherings"
    },
    {
      id: 3,
      src: "/resources/images/corporate-social/img3.jpg",
      category: "Corporate Events",
      title: "Corporate Milestones"
    },
    {
      id: 4,
      src: "/resources/images/corporate-social/img4.jpg",
      category: "Corporate Events",
      title: "Professional Moments"
    },
    {
      id: 5,
      src: "/resources/images/corporate-social/img5.jpg",
      category: "Social Impact",
      title: "Community Initiatives"
    },
    {
      id: 6,
      src: "/resources/images/corporate-social/img6.jpg",
      category: "Social Impact",
      title: "Making a Difference"
    },
    {
      id: 7,
      src: "/resources/images/corporate-social/img7.jpg",
      category: "Social Impact",
      title: "Social Change"
    },
    {
      id: 8,
      src: "/resources/images/corporate-social/img8.jpg",
      category: "Social Impact",
      title: "Community Engagement"
    },
    {
      id: 9,
      src: "/resources/images/corporate-social/img9.jpg",
      category: "Corporate Events",
      title: "Business Excellence"
    },
    {
      id: 10,
      src: "/resources/images/corporate-social/img10.jpg",
      category: "Corporate Events",
      title: "Professional Development"
    },
    {
      id: 11,
      src: "/resources/images/corporate-social/img11.jpg",
      category: "Social Impact",
      title: "Community Outreach"
    },
    {
      id: 12,
      src: "/resources/images/corporate-social/img12.jpg",
      category: "Social Impact",
      title: "Social Initiatives"
    },
    {
      id: 13,
      src: "/resources/images/corporate-social/img13.jpg",
      category: "Corporate Events",
      title: "Corporate Leadership"
    },
    {
      id: 14,
      src: "/resources/images/corporate-social/img14.jpg",
      category: "Corporate Events",
      title: "Business Innovation"
    },
    {
      id: 15,
      src: "/resources/images/corporate-social/img15.jpg",
      category: "Social Impact",
      title: "Community Development"
    },
    {
      id: 16,
      src: "/resources/images/corporate-social/img16.jpg",
      category: "Social Impact",
      title: "Social Progress"
    },
    {
      id: 17,
      src: "/resources/images/corporate-social/img17.jpg",
      category: "Corporate Events",
      title: "Professional Growth"
    },
    {
      id: 18,
      src: "/resources/images/corporate-social/img18.JPG",
      category: "Corporate Events",
      title: "Business Success"
    },
    {
      id: 19,
      src: "/resources/images/corporate-social/img19.jpg",
      category: "Social Impact",
      title: "Community Impact"
    },
    {
      id: 20,
      src: "/resources/images/corporate-social/img20.jpeg",
      category: "Social Impact",
      title: "Social Transformation"
    },
    {
      id: 21,
      src: "/resources/images/corporate-social/img21.JPG",
      category: "Corporate Events",
      title: "Corporate Achievement"
    },
    {
      id: 22,
      src: "/resources/images/celebrity/celeb1.jpg",
      category: "Celebrity Events",
      title: "Kalki Koechlin"
    },
    {
      id: 23,
      src: "/resources/images/celebrity/celeb2.jpg",
      category: "Celebrity Events",
      title: "Vidya Balan"
    },
    {
      id: 24,
      src: "/resources/images/celebrity/celeb3.jpg",
      category: "Celebrity Events",
      title: "Rahul Vaidya"
    }
  ];

  return (
    <div className="portfolio-detail-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="portfolio-detail-hero">
        <h1 className="detail-hero-title">Corporate & Social Impact</h1>
        <div className="title-line"></div>
        <p className="detail-hero-subtitle">Documenting Professional Excellence and Community Impact</p>
      </section>

      {/* Introduction */}
      <section className="portfolio-intro">
        <div className="intro-content">
          <h2>Professional Excellence & Social Change</h2>
          <p>At Stories by Kalakaar, we capture both the sophistication of corporate events and the meaningful moments of social impact initiatives. Our photography bridges the gap between professional excellence and community engagement, documenting stories that matter in both the corporate and social spheres.</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="portfolio-gallery">
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-item">
              <div className="image-wrapper">
                <img src={image.src} alt={image.title} />
                <div className="image-overlay">
                  <div className="image-info">
                    <span className="image-category">{image.category}</span>
                    <h3 className="image-title">{image.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="portfolio-services">
        <div className="services-content">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-item">
              <h3>Corporate Events</h3>
              <p>Professional coverage of conferences, meetings, and corporate gatherings</p>
            </div>
            <div className="service-item">
              <h3>Social Initiatives</h3>
              <p>Documenting community programs and social impact projects</p>
            </div>
            <div className="service-item">
              <h3>Professional Portraits</h3>
              <p>Corporate headshots and team photography</p>
            </div>
            <div className="service-item">
              <h3>Event Documentation</h3>
              <p>Comprehensive coverage of both corporate and social events</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="portfolio-cta">
        <div className="cta-content">
          <h2>Ready to Document Your Impact?</h2>
          <p>Let's capture your professional excellence and social initiatives</p>
          <a href="/contactUs" className="cta-button">Get in Touch</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}; 